import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Spin, Upload } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message'; // 提示信息弹窗 
import trans from './translation';

const BatchInactiveModal = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [uploadFileList, setUploadFileList] = useState([]);

    useEffect(() => {
        form.setFieldsValue({});
    }, []);

    const uploadChange = (e) => {
        messageShowHandler();
        setUploadFileList([e.file]);
    }

    const removeFile = () => {
        setUploadFileList([]);
    }

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const save = () => {
        if (Base.stopClick() && !isLoad) {
            if (!uploadFileList || uploadFileList.length < 1) {
                errFrameShow("error", trans.noFileSelected[Config.backLang]);
                return;
            }
            messageShowHandler();
            let formData = new FormData();
            let file = uploadFileList[0].originFileObj;
            formData.append("files", file);
            setIsLoad(true);
            fetch(Config.apiDownloadServer + "studentInactiveHandler/uploadExcel", {
                method: 'POST',
                body: formData,
                headers: { 'authorization': Config.header.authorization, 'x-auth-token': Config.header['x-auth-token'], 'func': Config.header.func },
                mode: 'cors',
                cache: 'default'
            }).then(res => res.blob()).then(blob => {
                if (blob.type == "application/json") {
                    var reader = new FileReader();
                    reader.onload = e => {
                        var data = JSON.parse(e.target.result);
                        if ("SUCCESS" === data.msg) {
                            props.onClose(true);
                        } else {
                            errFrameShow("error", data.msg);
                        }
                    }
                    reader.readAsText(blob);
                } else {
                    let filename = "StudentTemplateErrorLog.xlsx";
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                        window.navigator.msSaveOrOpenBlob(blob, filename);
                    } else {// for Non-IE (chrome, firefox etc.)
                        var a = document.createElement('a');
                        document.body.appendChild(a);
                        a.style = 'display: none';
                        var url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = filename;
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                    }
                }
            }).catch(err => ({ err })).finally(() => {
                setIsLoad(false)
            });
        }
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }

    return (
        <Spin size="large" spinning={isLoad} tip={trans.dataBeSaving[Config.backLang]}>
            <Modal
                visible={true}//控制弹框是否显示
                title={"Batch Inactive Student"}//标题
                centered//垂直居中
                destroyOnClose={true}//关闭即销毁？
                closable//是否显示右上角的关闭按钮
                maskClosable={false}//点击蒙层是否允许关闭	
                // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
                width={'768px'}
                onCancel={() => onCancel(false)}//点击取消触发事件
                footer={[
                    <Button key='save' className="sysBtn btnBlue" type="primary" onClick={save} icon={<CheckCircleOutlined />}>{trans.saveUpload[Config.backLang]}</Button>,
                    <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                ]}
            >
                <Message ref={messageRef} />
                <div className='sysRow'>
                    <div className='sysCol'>
                        <div className="sysParams mustFill">Select File (Excel/CSV)</div>
                        <div className="" style={{ width: "400px", marginLeft: "20px" }}>
                            <div style={{ float: "left " }}>
                                <Upload
                                    action={Config.uploadTestServer}
                                    key="uploadFile"
                                    accept={".xlsx,.xls"}
                                    maxCount={1}
                                    fileList={uploadFileList}
                                    onChange={(e) => uploadChange(e)}
                                    showUploadList={false}>
                                    <Button icon={<UploadOutlined />}>Select File</Button>
                                </Upload>
                            </div>
                            <span style={{ marginLeft: "10px", float: "left", height: "32px", lineHeight: "32px" }}>
                                {Base.isNotEmpty(uploadFileList) ?
                                    <div style={{ display: "flex", maxWidth: "400px" }}>
                                        <div className='fileNameCl' style={{ color: "#000" }} >
                                            {uploadFileList[0].name}
                                        </div>
                                        &nbsp;&nbsp;&nbsp;
                                        <DeleteOutlined style={{ display: "inline-flex", alignItems: "center" }} onClick={removeFile} />
                                    </div>
                                    : null}
                            </span>
                        </div>
                    </div>
                </div>
            </Modal>
        </Spin>
    )

}

BatchInactiveModal.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default BatchInactiveModal;